<template>
  <div>
    <v-checkbox
      v-model="sourceNews"
      @click="handleCheckboxChange('news')"
      class="category-input"
      dense
    >
      <template v-slot:label>
        News<span class="filter-count">{{
          formatFilterCount(sourceFilterCounts, "news")
        }}</span>
      </template>
    </v-checkbox>
    <v-checkbox
      v-if="hasSocialAccess"
      v-model="sourceSocial"
      @click="handleCheckboxChange('social')"
      class="category-input"
      dense
    >
      <template v-slot:label>
        Social<span class="filter-count">{{
          formatFilterCount(sourceFilterCounts, "social")
        }}</span>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
import { hasTwitterAccess } from "@/services/user/user.service";
import lodashGet from "lodash/get";
import { formatBigNumber } from "@/common/basic.utilities";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "SearchFilterSource",
  props: {
    selected: {
      type: Object,
    },
    sourceFilterCounts: {
      type: Object,
    },
    reset: {
      type: String,
    },
  },
  data() {
    return {
      sourceNews: false,
      sourceSocial: false,
    };
  },
  computed: {
    hasSocialAccess() {
      return hasTwitterAccess();
    },
  },
  mounted() {
    if (this.selected) {
      this.sourceNews = this.isSourceSelected("news");
      this.sourceSocial = false;
      if (this.hasSocialAccess) {
        this.sourceSocial = this.isSourceSelected("social");
      }
    } else {
      this.sourceNews = false;
      this.sourceSocial = false;
    }
  },
  methods: {
    handleCheckboxChange() {
      let sources = {};
      sources["news"] = this.sourceNews;
      sources["social"] = false;
      if (this.hasSocialAccess) {
        sources["social"] = this.sourceSocial;
      }
      this.$emit(EMITTED_ACTIONS.CHANGE, sources);
    },
    formatFilterCount(sourceFilterCounts, source) {
      let count = lodashGet(sourceFilterCounts, source);
      if (count || count === 0) {
        return `(${formatBigNumber(count)})`;
      }
    },
    isSourceSelected(sourceName) {
      return !!sourceName && this.selected
        ? this.selected.hasOwnProperty(sourceName)
          ? this.selected[sourceName]
          : false
        : null;
    },
  },
  watch: {
    reset: {
      handler() {
        this.sourceNews = false;
        this.sourceSocial = false;
        this.handleCheckboxChange();
      },
    },
    selected: {
      handler() {
        this.sourceNews = this.isSourceSelected("news");
        this.sourceSocial = this.isSourceSelected("social");
      },
    },
  },
};
</script>

<style scoped>
.category-input {
  margin: 4px;
}
.category-input >>> .v-label {
  color: #1c1c1c;
  font-size: 13px !important;
  font-family: TruenoRg;
}
.filter-count {
  padding-left: 5px;
  font-family: TruenoLt;
}
.category-input >>> .v-messages {
  min-height: 0 !important;
}
.category-input >>> .v-input__slot {
  margin: 0 !important;
}
</style>
